import { TaskProjectStatus, TaskProjectView } from '@common/interfaces/taskProject'
import Base from './base'

export default class TaskProjects extends Base {
  list(params?: object) {
    return this.apiClient.get('/task-projects', params)
  }

  create(data: object) {
    return this.apiClient.post('/task-projects', data)
  }

  show(id: string) {
    return this.apiClient.get(`/task-projects/${id}`)
  }

  listFavorites() {
    return this.apiClient.get('/task-projects/favorites')
  }

  setFavorite(id: string, data: { isFavorite: boolean }) {
    return this.apiClient.put(`/task-projects/${id}/favorite`, data)
  }

  setMyTasksVisibility(id: string, data: { showInMyTasks: boolean }) {
    return this.apiClient.put(`/task-projects/${id}/my-tasks-visibility`, data)
  }

  setView(id: string, data: { view: TaskProjectView }) {
    return this.apiClient.put(`/task-projects/${id}/view`, data)
  }

  setStatus(id: string, data: { status: TaskProjectStatus }) {
    return this.apiClient.put(`/task-projects/${id}/status`, data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`/task-projects/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/task-projects/${id}`)
  }

  listTasks(id: string, params: object = {}) {
    return this.apiClient.get(`/task-projects/${id}/tasks`, params)
  }

  getStatusSummary(id: string) {
    return this.apiClient.get(`/task-projects/${id}/status-summary`)
  }

  refreshStatusSummary(id: string) {
    return this.apiClient.post(`/task-projects/${id}/status-summary/refresh`, {})
  }

  saveStatusUpdate(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/status-summary`, data)
  }

  markAllTasksRead(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/read`, data)
  }

  addMember(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/members`, data)
  }

  updateMemberRole(id: string, userId: string, data: object) {
    return this.apiClient.put(`/task-projects/${id}/members/${userId}`, data)
  }

  removeMember(id: string, userId: string) {
    return this.apiClient.delete(`/task-projects/${id}/members/${userId}`)
  }

  createSection(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/sections`, data)
  }

  reorderSections(id: string, data: { sectionIds: string[] }) {
    return this.apiClient.put(`/task-projects/${id}/sections/reorder`, data)
  }

  updateSection(id: string, sectionId: string, data: object) {
    return this.apiClient.put(`/task-projects/${id}/sections/${sectionId}`, data)
  }

  deleteSection(id: string, sectionId: string) {
    return this.apiClient.delete(`/task-projects/${id}/sections/${sectionId}`)
  }

  addTask(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/tasks`, data)
  }

  addTasks(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/tasks/bulk`, data)
  }

  moveTask(id: string, taskId: string, data: object) {
    return this.apiClient.put(`/task-projects/${id}/tasks/${taskId}`, data)
  }

  removeTask(id: string, taskId: string) {
    return this.apiClient.delete(`/task-projects/${id}/tasks/${taskId}`)
  }

  listCustomFields(id: string) {
    return this.apiClient.get(`/task-projects/${id}/custom-fields`)
  }

  attachCustomField(id: string, data: object) {
    return this.apiClient.post(`/task-projects/${id}/custom-fields`, data)
  }

  updateCustomField(id: string, fieldId: string, data: object) {
    return this.apiClient.put(`/task-projects/${id}/custom-fields/${fieldId}`, data)
  }

  reorderCustomFields(id: string, orderedFieldIds: string[]) {
    return this.apiClient.put(`/task-projects/${id}/custom-fields/reorder`, { orderedFieldIds })
  }

  detachCustomField(id: string, fieldId: string) {
    return this.apiClient.delete(`/task-projects/${id}/custom-fields/${fieldId}`)
  }
}
